import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useLocation } from 'react-router-dom'
import logo from '../assets/logo.png'
import { navLinks } from '../Data/data';
import { IoClose,IoMenu } from "react-icons/io5";
import { Buttons } from './Buttons';

const LanguageToggle = ({ mobile = false }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem('millennium-language') || 'en');
  const [isChanging, setIsChanging] = useState(false);

  useEffect(() => {
    window.googleTranslateElementInit = () => {
      if (window.google?.translate?.TranslateElement) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: 'en',
            includedLanguages: 'en,ko',
            autoDisplay: false,
          },
          'google_translate_element'
        );
      }
    };

    if (!document.querySelector('script[data-google-translate]')) {
      const script = document.createElement('script');
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      script.dataset.googleTranslate = 'true';
      document.body.appendChild(script);
    } else if (window.google?.translate?.TranslateElement) {
      window.googleTranslateElementInit();
    }
  }, []);

  const changeLanguage = (nextLanguage) => {
    if (nextLanguage === language || isChanging) return;

    setIsChanging(true);
    setLanguage(nextLanguage);
    localStorage.setItem('millennium-language', nextLanguage);

    const select = document.querySelector('.goog-te-combo');
    if (!select) {
      setIsChanging(false);
      return;
    }

    // Google Translate exposes the source language as the explicit `en` option.
    // Using an empty value only changes the custom toggle state, not the page language.
    select.value = nextLanguage === 'ko' ? 'ko' : 'en';
    select.dispatchEvent(new Event('change'));

    // Google Translate updates the page asynchronously. Keep the switch busy
    // while that update settles, with a fallback for slow or blocked requests.
    window.setTimeout(() => setIsChanging(false), 900);
  };

  return (
    <div
      className={`${mobile ? 'flex w-fit' : 'flex'} notranslate items-center rounded-full border border-[#3a3a3a] bg-[#111] p-[0.2rem]`}
      aria-label="Language selector"
      aria-busy={isChanging}
      translate="no"
    >
      <button
        type="button"
        onClick={() => changeLanguage('en')}
        disabled={isChanging}
        aria-pressed={language === 'en'}
        className={`rounded-full px-[0.7rem] py-[0.35rem] text-[12px] font-semibold tracking-[0.04em] transition-colors disabled:cursor-wait ${language === 'en' ? 'bg-[#EEC24B] text-black' : 'text-[#BDBDBD] hover:text-white'}`}
      >
        {isChanging && language === 'en' ? <span className="mr-[0.3rem] inline-block h-[10px] w-[10px] animate-spin rounded-full border-2 border-black/30 border-t-black" aria-hidden="true" /> : null}
        EN
      </button>
      <button
        type="button"
        onClick={() => changeLanguage('ko')}
        disabled={isChanging}
        aria-pressed={language === 'ko'}
        className={`rounded-full px-[0.7rem] py-[0.35rem] text-[12px] font-semibold tracking-[0.04em] transition-colors disabled:cursor-wait ${language === 'ko' ? 'bg-[#EEC24B] text-black' : 'text-[#BDBDBD] hover:text-white'}`}
      >
        {isChanging && language === 'ko' ? <span className="mr-[0.3rem] inline-block h-[10px] w-[10px] animate-spin rounded-full border-2 border-black/30 border-t-black" aria-hidden="true" /> : null}
        한국어
      </button>
    </div>
  );
};

const Navbar = () => {
    const location = useLocation();
    const [isOpen,setIsOpen] =useState(false);
  return (
    <header className="sticky top-0 z-[70]">
    <Topbar/>
     <div className='relative w-full border-b border-[#262626] bg-[#1A1A1A] px-4 py-2 shadow-lg shadow-black/20 sm:px-6 lg:px-8'> 
            
        <div className="max-w-[1440px] mx-auto  flex justify-between items-center">
          {/* Logo */}
          
            <Link to="/" aria-label="Millennium Realty home">
              <img
                src={logo}
                alt="Millennium Realty"
                className="h-[62px] w-[132px] cursor-pointer object-contain sm:h-[76px] sm:w-[155px] lg:h-[100px] lg:w-[200px]"
              />
            </Link>
          
          {/* Desktop Links */}
         <div className="hidden lg:flex items-center py-[1rem] px-[2rem] gap-4 text-[16px] font-Outfit">
      {navLinks.map((link) => {
        const isActive = location.pathname === link.link; // check if link is active
        return (
          <Link
            key={link.id}
            to={link.link}
            className={`
              relative inline-block group text-white font-normal 
              px-[0.8rem] py-[0.5rem] rounded-lg 
              transition-all duration-300 ease-in-out
              hover:bg-[#141414] hover:border hover:border-[#262626]
              ${isActive ? "bg-[#141414] border border-[#262626]" : ""}
            `}
          >
            {link.title}
          </Link>
        );
      })}
    </div>

          {/* Desktop Icons */}
          <div className="hidden lg:flex items-center gap-6 text-[20px] text-white">
                
          </div>
           
        <div className="hidden items-center gap-[0.8rem] lg:flex">
                <LanguageToggle />
                <Buttons title="Get a Quote" width="200px" to="/contact" />
          </div>
          {/* Mobile Menu Button */}
          <div className="flex items-center gap-2 lg:hidden">
            <LanguageToggle mobile />
            <button
              onClick={() => setIsOpen(!isOpen)}
              aria-label={isOpen ? 'Close menu' : 'Open menu'}
              className="flex min-h-11 min-w-11 items-center justify-center text-3xl text-white hover:text-[#f0dc82] transition-colors duration-300 ease-in-out"
            >
              {isOpen ? <IoClose /> : <IoMenu />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="absolute left-0 top-full z-50 flex w-full flex-col gap-1 border-b border-[#262626] bg-black/95 px-4 py-4 text-white font-Outfit shadow-xl backdrop-blur-md sm:px-6">
            {navLinks.map((link, idx) => (
              <Link
                key={idx}
                to={link.link}
                className="flex min-h-11 items-center rounded-lg px-3 text-base hover:bg-[#141414] hover:text-[#f0dc82] transition-colors duration-300 ease-in-out"
                onClick={() => setIsOpen(false)}
              >
                {link.title}
              </Link>
            ))}

          
          </div>
        )}
        <div id="google_translate_element" className="google-translate-hidden" aria-hidden="true" />
     </div>
    </header>
  )
}

export default Navbar
